import { useSubmitFormAnswersMutation } from '@graphql/generated';
import { EventFormValues } from '../../../presentational/hooks/useEventFormState';
import { formStateToAnswers } from '../../shared/answersToFormState';
import { useToast } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

const useSendBasicForm = () => {
  const [mutation] = useSubmitFormAnswersMutation();

  const sendBasicForm = async (data: EventFormValues & { formId: string; guestKey: string | undefined }) => {
    const { formValues, formId, guestKey } = data;

    const { data: response } = await mutation({
      variables: {
        input: {
          formId,
          guestKey,
          answers: formStateToAnswers(formValues, null),
        },
      },
    });

    return response;
  };

  return { sendBasicForm };
};

export const useSaveBasicForm = () => {
  const { sendBasicForm } = useSendBasicForm();
  const { toast } = useToast();
  const { tq } = useTranslation('eventFormDisplay');

  const saveBasicForm = async (data: EventFormValues & { formId: string; guestKey: string | undefined }) => {
    try {
      await sendBasicForm(data);
    } catch (error) {
      toast(tq`Error saving form. Please try again later.`);
    }
  };

  return { saveBasicForm };
};
